import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';

import { env } from '@amfam/environment';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import { fromRouterActions } from '@amfam/shared/utility/navigation/lib/+state/router-actions';

function redirect(store: Store, data: Data): Observable<boolean> {
  if (data?.['redirectUrlKey']) {
    const redirectUrl = (env as unknown as Record<string, unknown>)[
      data?.['redirectUrlKey']
    ] as string;
    location.replace(redirectUrl);
  } else if (data?.['redirectRoute']) {
    store.dispatch(
      fromRouterActions.Go({
        path: [data?.['redirectRoute']]
      })
    );
  } else {
    store.dispatch(
      fromRouterActions.Go({
        path: ['/login']
      })
    );
  }
  return observableOf(false);
}

export const featureFlagGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean> => {
  const featureFlagService = inject(FeatureFlagService);
  const store = inject(Store);

  const data = route.data;
  if (data['feature']) {
    const feature = data['feature'];
    if (featureFlagService.isEnabled(feature)) {
      return observableOf(true);
    }
  }
  return redirect(store, data);
};
